// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance, {
  adminAxiosFormInstance,
} from "../../../api/adminAxiosInstance";

import { endpoints } from "../../../api/endpoints";

export const addupdateservicedetailsApi = createAsyncThunk(
  "Services/addupdateservicedetailsApi",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await adminAxiosFormInstance.post(
        endpoints.addupdateservicedetails,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getallservicedetails = createAsyncThunk(
  "Services/getallservicedetails",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.getallservicedetails,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const dltService = createAsyncThunk(
  "AdminAuthSlice/dltService",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.deleteservicedetail,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const ServicesSlice = createSlice({
  name: "ServicesSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addupdateservicedetailsApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getallservicedetails.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(dltService.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addupdateservicedetailsApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getallservicedetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(dltService.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(addupdateservicedetailsApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getallservicedetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(dltService.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default ServicesSlice.reducer;
